import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';

import { CrmConfig } from '@frontend/sports/common/client-config-data-access';
import { Odds, OddsFormatterService } from '@frontend/sports/odds/feature';
import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';

import { oddsBoostAnimations } from '../../../reward-tokens/components/digital/odds-boost-animations';

@Component({
    selector: 'bs-result-odds',
    templateUrl: './result-odds.component.html',
    styleUrls: ['./result-odds.component.scss'],
    animations: [oddsBoostAnimations],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ResultOddsComponent implements OnChanges {
    @Input() odds: Odds;
    @Input() boostedOdds: Odds | undefined;
    @Input() oddsDisplayFormat?: OddsDisplayFormat;
    @Input() withAnimation = true;

    formattedOdds: string;
    formattedBoostedOdds: string;

    constructor(
        private oddsFormatter: OddsFormatterService,
        protected crmConfig: CrmConfig,
    ) {}

    ngOnChanges(): void {
        this.formattedOdds = this.format(this.odds);
        this.formattedBoostedOdds = this.format(this.boostedOdds);
    }

    get isBoosted(): boolean {
        return !!this.boostedOdds;
    }

    private format(odds: Odds | undefined): string {
        return this.oddsFormatter.format(odds, {
            displayFormat: this.oddsDisplayFormat ?? OddsDisplayFormat.EU,
            maxDecimalPlaces: this.crmConfig.tokens.boostedOddsMaxDecimalPlaces,
            useOddsMultiplicationFormat: true,
        });
    }
}
